import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCsswizardryComponent } from './simple-icons-csswizardry.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCsswizardryComponent ],
    exports:      [ SimpleIconsCsswizardryComponent ],
    bootstrap:    []
})
export class SimpleIconsCsswizardryModule {}
